import { 
    Button, 
    faArrowLeftRotate, 
    FontAwesomeIcon, 
    HashLink, 
    useMediaQuery
} from "../../../../Constants/libraries"
import { 
    title,
    content_first_p1,  
    content_first_bullets,
    content_second_title,
    content_second_p1,
    content_third_title,
    content_third_p1,
    content_third_p2
} from "./Constants"
import { CTA } from "../../../CTA/CTA"

import "../../ServicesSubpages.css"


export const Communication = () => {

    const tablet = useMediaQuery({ query: '(max-width: 780px)' })
    const background = tablet ? "https://smscs-frontend.s3.ap-southeast-1.amazonaws.com/Services/Services_All_Thumbnails_Resized/services_communication.jpg" : "https://smscs-frontend.s3.ap-southeast-1.amazonaws.com/Services/Services_All_Thumbnail_Backgrounds/services_communication_background.jpg"
    
    return (
        <>
            <div 
                id=">"
                className="Communication Services__Subpage"
                style={{
                    background: "#000000",
                    backgroundImage: `url(${background})`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                }}
            >
                <div className="Services__Subpage__Overlay"></div>

                <div className="Services__Subpage__Overlay-cancel">
                    {/* Content */}
                    {!tablet && 
                        <div className="Services__Subpage__Content">
                            <p>{content_first_p1}</p>
                            <ul>
                                {content_first_bullets.map((item, index) => (
                                    <li key={index}>{item}</li>
                                ))}
                            </ul>
                            <hr />

                            <h1>{content_second_title}</h1>
                            <p>{content_second_p1}</p>
                            <hr />

                            <h1>{content_third_title}</h1>
                            <p>{content_third_p1}</p>
                            <p>{content_third_p2}</p>
                            <hr />
                        </div>
                    }

                    {/* Empty div for flexbox */}
                    <div className="Services__Subpage__Content-flex">
                        <p>{title}</p>
                        <Button>
                            <HashLink smooth to="/services#>">
                                <span><FontAwesomeIcon icon={faArrowLeftRotate}/></span>
                                SERVICES
                            </HashLink>
                        </Button>
                    </div>
                </div>
            </div>

            {/* Content layout for mobile */}
            {tablet && 
                <div className="Services__Subpage__Content">
                    <p>{content_first_p1}</p>
                    <ul>
                        {content_first_bullets.map((item, index) => (
                            <li key={index}>{item}</li>
                        ))}
                    </ul>
                    <hr />

                    <h1>{content_second_title}</h1>
                    <p>{content_second_p1}</p>
                    <hr />

                    <h1>{content_third_title}</h1>
                    <p>{content_third_p1}</p>
                    <p>{content_third_p2}</p>
                    <hr />
                </div>
            }
            
            {/* CTA */}
            <CTA />
        </>
    )
}